import { Component } from '@angular/core';

@Component({
  selector: 'ngx-catalogue-widget',
  templateUrl: './catalogue-widget.component.html',
  styleUrls: ['./catalogue-widget.component.scss']
})
export class CatalogueWidgetComponent {
  constructor(){}
}
